import router, { getRoot } from 'core/router';
import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import store from 'store/store';
class ReturnsBreadcrumbs extends Component {
    bindEvents(add = true) {
        const emitterMethod = add ? 'listenAndStart' : 'unlisten';
        const method = bindMethod(add);
        store.returnsStep[emitterMethod](this.onStepUpdate);
        this.refs.breadcrumbSteps.forEach((step, i) => {
            step[method]('click', this.onStepClick);
        });
    }
    onStepUpdate = (stepNumber) => {
        this.refs.breadcrumbSteps.forEach((step, i) => {
            step.classList.toggle('current', (i + 1) === stepNumber);
            step.classList.toggle('disabled', (i + 1) > stepNumber);
            if ((i + 1) === stepNumber) {
                this.el.scrollTo({
                    left: step.offsetLeft - this.el.offsetWidth / 2 + step.offsetWidth / 2,
                    behavior: 'smooth'
                });
            }
        });
    };
    onStepClick = (event) => {
        const target = event?.currentTarget;
        const url = target?.dataset.url;
        if (target?.classList.contains('disabled'))
            return;
        if (url)
            router.navigate(url?.replace(getRoot(), ''));
    };
}
export default ReturnsBreadcrumbs;
